import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38cd7678"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "overview-layout",
  "aria-label": "监控总览"
}
const _hoisted_2 = { class: "overview-card overview-primary" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "section-eyebrow" }, "Fleet Health", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "在线节点", -1))
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = ["aria-valuenow"]
const _hoisted_7 = { class: "overview-meta" }
const _hoisted_8 = { class: "overview-card metric-card" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "metric-label" }, "当前速率", -1))
const _hoisted_10 = { class: "overview-card metric-card" }
const _hoisted_11 = { class: "metric-label" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = ["aria-valuenow"]
const _hoisted_17 = { class: "overview-card metric-card" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "metric-label" }, "最高负载", -1))
const _hoisted_19 = { class: "overview-card fleet-card" }
const _hoisted_20 = { class: "fleet-head" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "section-eyebrow" }, "Node Map"),
  /*#__PURE__*/_createElementVNode("h3", null, "节点状态")
], -1))
const _hoisted_22 = { class: "fleet-count" }
const _hoisted_23 = { class: "fleet-list" }
const _hoisted_24 = { class: "fleet-main" }
const _hoisted_25 = { class: "fleet-usage" }
const _hoisted_26 = {
  class: "mini-track",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("article", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createElementVNode("h2", null, _toDisplayString(_ctx.onlineCount) + " / " + _toDisplayString(_ctx.totalCount), 1),
        _hoisted_4
      ]),
      _createElementVNode("div", {
        class: "availability-ring",
        style: _normalizeStyle({ '--value': `${_ctx.availabilityPercent}%` }),
        role: "img",
        "aria-label": `在线率 ${_ctx.availabilityPercent}%`
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.availabilityPercent) + "%", 1)
      ], 12, _hoisted_5),
      _createElementVNode("div", {
        class: "overview-track",
        role: "progressbar",
        "aria-label": "在线率",
        "aria-valuenow": _ctx.availabilityPercent,
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      }, [
        _createElementVNode("span", {
          style: _normalizeStyle({ width: `${_ctx.availabilityPercent}%` })
        }, null, 4)
      ], 8, _hoisted_6),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", null, "离线 " + _toDisplayString(_ctx.offlineCount), 1),
        _createElementVNode("span", null, "平均 CPU " + _toDisplayString(_ctx.averageCpu) + "%", 1)
      ])
    ]),
    _createElementVNode("article", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("strong", null, _toDisplayString(_ctx.byteConvert(_ctx.totalRate)) + "/s", 1),
      _createElementVNode("p", null, "下行 " + _toDisplayString(_ctx.byteConvert(_ctx.totalRx)) + "/s · 上行 " + _toDisplayString(_ctx.byteConvert(_ctx.totalTx)) + "/s", 1)
    ]),
    _createElementVNode("article", _hoisted_10, [
      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.trafficEnabled ? '本月流量' : '累计流量'), 1),
      _createElementVNode("strong", null, _toDisplayString(_ctx.byteConvert(_ctx.trafficEnabled ? _ctx.monthlyUsed : _ctx.totalTraffic)), 1),
      (_ctx.trafficEnabled && _ctx.monthlyLimit)
        ? (_openBlock(), _createElementBlock("p", _hoisted_12, " 限额节点 " + _toDisplayString(_ctx.byteConvert(_ctx.monthlyLimitedUsed)) + " / " + _toDisplayString(_ctx.byteConvert(_ctx.monthlyLimit)) + " · " + _toDisplayString(_ctx.monthlyPercent) + "% ", 1))
        : (_ctx.trafficEnabled)
          ? (_openBlock(), _createElementBlock("p", _hoisted_13, "全部不限额，仅统计用量"))
          : (_ctx.totalTrafficLimit)
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, "额度合计 " + _toDisplayString(_ctx.byteConvert(_ctx.totalTrafficLimit)) + " · " + _toDisplayString(_ctx.trafficPercent) + "%", 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_15, "未配置流量额度")),
      (_ctx.trafficEnabled && _ctx.monthlyLimit)
        ? (_openBlock(), _createElementBlock("div", {
            key: 4,
            class: "overview-track metric-track",
            role: "progressbar",
            "aria-label": "本月流量用量",
            "aria-valuenow": _ctx.monthlyPercent,
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.monthlyLevel),
              style: _normalizeStyle({ width: `${_ctx.monthlyBarWidth}%` })
            }, null, 6)
          ], 8, _hoisted_16))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("article", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("strong", null, _toDisplayString(_ctx.topLoadValue), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.topLoadName), 1)
    ]),
    _createElementVNode("aside", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.totalCount) + " 台", 1)
      ]),
      _createElementVNode("div", _hoisted_23, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.safeServers, (server) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `${server.name}-${server.host}`,
            class: "fleet-row"
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["status-dot", { online: _ctx.isOnline(server) }])
            }, null, 2),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("strong", null, _toDisplayString(server.name), 1),
              _createElementVNode("span", null, _toDisplayString(server.type) + " · " + _toDisplayString(server.location), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("span", null, _toDisplayString(server.cpu ?? 0) + "%", 1),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("span", {
                  style: _normalizeStyle({ width: `${_ctx.cpuPercent(server)}%` })
                }, null, 4)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}